import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import { requiresShipping } from 'checkout/checkout/helpers';
import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { FormError } from 'common/components/layout';
import {
  getDefaultCountryCode,
  getOperatingCountryCodes,
  getCartTitle
} from 'common/helpers/miscHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { updateCart } from 'redux/cart/actions';

import Email from './components/Email';
import GiftMessage from './components/GiftMessage';
import ShippingInstructions from './components/ShippingInstructions';
import { validateForNotLoggedInCustomerShip } from './validators';

class Customer extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const cart = {
      email: data.email,
      isSubscribe: data.isSubscribe,
      shipTo: data,
      giftMessage: data.giftMessage,
      shippingInstructions: data.shippingInstructions,
      orderDeliveryMethod: 'Ship'
    };
    cart.shipTo.potentiallyCopyToBillTo = true;
    delete cart.shipTo.email;
    delete cart.shipTo.isSubscribe;
    delete cart.shipTo.giftMessage;
    delete cart.shipTo.shippingInstructions;
    const successFunction = () => {
      props.onEdit('shipping');
    };
    props.updateCart(cart, successFunction);
  };

  handlePickup = (e) => {
    e.preventDefault();
    const { onPickup } = this.props;
    onPickup();
  };

  render() {
    const { change, handleSubmit, form, cart, settings } = this.props;
    const object = { countryCode: getDefaultCountryCode(settings) };
    const title = getCartTitle(settings);
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <Email />
        <p>&nbsp;</p>
        <div className="c7-checkout__content__title">
          <h3>Shipping address</h3>
          <a
            className="c7-checkout__content__title__pickup"
            onClick={this.handlePickup}
          >
            I prefer to pick up my order
          </a>
        </div>
        <AddressForm
          object={object}
          changeFunction={change}
          type="Operating"
          settings={settings}
        />

        <GiftMessage cart={cart} />
        <ShippingInstructions cart={cart} />
        <div className="c7-checkout__content__buttons">
          {renderButton(cart)}
          <a href="/cart">Return to {title.toLowerCase()}</a>
        </div>
      </Form>
    );
  }
}

const renderButton = (cart) => {
  if (requiresShipping(cart)) {
    return (
      <button className="c7-button" type="submit">
        Continue to shipping method
      </button>
    );
  }
  return (
    <button className="c7-button" type="submit">
      Continue to payment method
    </button>
  );
};

const transformData = (values) => {
  const data = transformAddressData(values);
  data.email = values.email;
  data.isSubscribe = values.isSubscribe || false;
  if (values.isGiftMessage) {
    data.giftMessage = values.giftMessage;
  } else {
    data.giftMessage = null;
  }
  if (values.isShippingInstructions) {
    data.shippingInstructions = values.shippingInstructions;
  } else {
    data.shippingInstructions = null;
  }

  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  data.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  data.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  data.birthYear = values.birthYear && convertStringToInteger(values.birthYear);
  const errors = validateForNotLoggedInCustomerShip(data, ownProps.settings);
  return errors;
};

const mapStateToProps = (state) => {
  let initialValues = {};
  if (state.cart && state.cart.data) {
    const { shipTo } = state.cart.data;
    initialValues = Object.assign(initialValues, initialFormValues(shipTo));
    initialValues.email = state.cart.data.email;
    initialValues.isSubscribe = state.cart.data.isSubscribe;
    initialValues.giftMessage = state.cart.data.giftMessage;
    initialValues.isGiftMessage = !!state.cart.data.giftMessage;

    initialValues.shippingInstructions = state.cart.data.shippingInstructions;
    initialValues.isShippingInstructions =
      !!state.cart.data.shippingInstructions;
  }
  if (
    !initialValues.countryCode ||
    getOperatingCountryCodes(state.setting).length === 1
  ) {
    initialValues.countryCode = getDefaultCountryCode(state.setting);
  }
  return {
    initialValues,
    settings: state.setting
  };
};

Customer = reduxForm({
  form: 'customerNotLoggedInShip',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Customer);

export default connect(mapStateToProps, { updateCart })(Customer);
